import React, { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import SelectFixo from "../../../../components/SelectFixo";

import SelectEmpresa from "../../../../components/Select/Empresa";
import SelectCentroCusto from "../../../../components/Select/CentroCusto";
import SelectComprador from "../../../../components/Select/Comprador";
import SelectFornecedor from "../../../../components/Select/Fornecedor";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, encryptAES, formatDateColumn, formatarComoMoeda } from "../../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../../components/ExportarExcel";
import MedicaoGCT from "../../../../../lib/json/consultas/MedicaoGCT.json"
import { handleFilialMedicao, handleFornecedorMedicao, handleTotalMedicao } from "../../../../components/GridCell/Medicao";


function ListaMedicaoGCT(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = MedicaoGCT.tabelas;
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("medicaoEmpresa", {value: "",text: "", });
    const [medicao, setMedicao] = useSessionStorageState("medicaoMedicao",'');
    const [dateDe, setDateDe] =  useSessionStorageState("medicaoDateDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("medicaoDateAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoStatus, setCampoStatus] = useSessionStorageState("medicaoCampoStatus", {value: '00', text: 'Todos'});
    const [contrato, setContrato] = useState('');
    const [fornecedor, setFornecedor, campoFornecedor] = useState('');
    

    var empresaCopiar = {value: '', text: ''};
    var scOrigem = '';
    var empresaOrigem = '';

    const options = [
        {
            value: '01',
            text: "Em Aprovação",
        },
        {
            value: '03',
            text: "Pendente",
        },
        {
            value: '02',
            text: "Pedido Gerado",
        },
        {
            value: '04',
            text: "Rejeitado",
        }
    ];

    const columns = [
        {
            Header: 'PC',
            accessor: "CND_FILIAL",
            Cell: handleFilialMedicao
        },
        {
            Header: 'Fornecedor',
            accessor: "CXN_FORNEC",
            Cell: handleFornecedorMedicao
        },
        {
            Header: 'Emissão',
            accessor: 'CND_DTINIC',
            Cell: formatDateColumn
        },
        {
            Header: 'Saldo/Total',
            accessor: 'TOTAL_CC',
            Cell: handleTotalMedicao
        },
        {
            Header: 'Status',
            accessor: "STATUS",
        }
    ]

    const excelColumns = [
        {
            Header: 'Filial',
            accessor: "CND_FILIAL",
        },
        {
            Header: 'Numero Medicao',
            accessor: "CND_NUMMED",
        },
        {
            Header: 'Contrato',
            accessor: "CND_CONTRA",
        },
        {
            Header: 'Revisao',
            accessor: "CND_REVISA",
        },
        {
            Header: 'Fornecedor',
            accessor: "CXN_FORNEC",
        },
        {
            Header: 'Loja',
            accessor: "CXN_LJFORN",
        },
        {
            Header: 'Nome',
            accessor: "A2_NOME",
        },
        {
            Header: 'Emissão',
            accessor: 'CND_DTINIC',
            Cell: formatDateColumn
        },
        {
            Header: 'Status',
            accessor: "STATUS",
        },
        {
            Header: 'Centro Custo',
            accessor: "CNE_CC",
        },
        {
            Header: 'Descrição Centro Custo',
            accessor: "CTT_DESC01",
        },
        {
            Header: 'Total Centro de Custo',
            accessor: "TOTAL_CC",
        },
        {
            Header: 'Total Medição',
            accessor: "TOTAL_MEDICAO",
        },
        {
            Header: 'Pedido',
            accessor: 'CNE_PEDIDO',
        },
    ]

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let filtros = '';

        filtros += "AND CND_FILIAL = FILIAL(CND)";
    
        if (medicao) {
            filtros += "AND CND_NUMMED = '"+medicao+"' ";
        }

        if (contrato) {
            filtros += "AND CND_CONTRA = '"+contrato+"' ";
        }

        if (fornecedor?.value) {
            filtros += "AND CXN_FORNEC + CXN_LJFORN = '"+fornecedor.value+"' ";
        }

        if (dateDe) {
            filtros += "AND CND_DTINIC >= '"+dateDe.replaceAll('-','')+"' ";
        }

        if (dateAte) {
            filtros += "AND CND_DTINIC <= '"+dateAte.replaceAll('-','')+"' ";
        }

        if (campoStatus && campoStatus.value && campoStatus.value !== '00') {
            const statusMap = {
                '01': "CND_ALCAPR = 'B'",                              // Em Aprovação
                '02': "CND_SITUAC = 'E'",                               // Pedido Gerado
                '03': "(CND_SITUAC = 'A' AND CND_ALCAPR = 'L')",        // Pendente 
                '04': "CND_ALCAPR = 'R'",        // Pendente 
            };
            if (statusMap[campoStatus.value]) {
                filtros += "AND "+statusMap[campoStatus.value]+" ";
            }
        }

        var consultaFinal = MedicaoGCT.consulta.replace('FILTRO', filtros);
        return consultaFinal;
    }

// Processa consulta do grid
    const listaMedicaoGCT = async () => {
        let dataAux = [];
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );

        if (retConsulta.error === '00'){
            dataAux = retConsulta.data;
        } else {
            ErroMsg(retConsulta.description);
        }

        setData(dataAux);
        setCarregar(false);
    }

    useEffect( () => {
       listaMedicaoGCT()
    },[])

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.CND_NUMMED}/${row.original.EMPRESA}${row.original.CND_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.CND_NUMMED}/${row.original.EMPRESA}${row.original.CND_FILIAL}`)
    }
    
     const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.CND_FILIAL + '|' + row.original.CND_NUMMED;
        const Mensagem = `Tem certeza que deseja excluir a Medição ${row.original.CND_NUMMED + ' - da Filial: ' + row.original.CND_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { Numero: row.split('|')[1] }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIR', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
        } finally {
            setCarregar(false);
            listaMedicaoGCT();
        }
    };

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Medição"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Medição"
                        tipo='text'
                        max="12"
                        value={medicao}  
                        onChange={(e) => setMedicao(e.target.value)}
                    />
                </Col>               
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Contrato"
                        tipo='text'
                        max="15"
                        value={contrato}  
                        onChange={(e) => setContrato(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="8" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>

            </Row>
            
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Medicoes"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaMedicaoGCT}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        linhaCondicional={(item) => item.CND_SITUAC == "R"}
                        columns={columns} 
                        data={data} 
                        buttons={[
                            // {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            // {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "(row.original.CND_SITUAC !== 'E')"}, 
                            // {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "(row.original.CND_SITUAC !== 'E')"},
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaMedicaoGCT;